module.exports = __webpack_public_path__ + "static/fonts/iconfont.6f00b6c.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/iconfont.ttf?t=1666072481651
// module id = XiJy
// module chunks = 96